import { createFileRoute } from '@tanstack/react-router'
import { AdminReviews } from '@/components/admin/marketing/AdminReviews'

export const Route = createFileRoute('/admin/marketing/reviews')({
  component: () => <AdminReviews />,
})
